
import store from '../../config/store'
import axios from '../../http'

export default {
  components: {
    CloseIcon: () => import(/* webpackChunkName: "svg" */ `../../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-close.svg`),
    IcAttachment: () => import(/* webpackChunkName: "svg" */ `../../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-attachment.svg`),
    IcRemove: () => import(/* webpackChunkName: "svg" */ `../../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-remove.svg`),
    'component-button': () => import(/* webpackChunkName: "components" */ '../Button.vue')
  },
  
  data: () => ({
    store,
    message: {
      subject: '',
      content: '',
      attachment: null
    }
  }),
  
  computed: {
    isResponse () {
      return store.modal.dataModel.response
    }
  },

  methods: {

    /**
     * onFileAttached
     * @param file
     */
    onFileAttached () {
      this.message.attachment = this.$refs.attachment.files[0]
    },

    /**
     * onSubmit
     * @param e
     */
    onSubmit (e) {
      this.$validator.validateAll().then(result => {
        if (result) {
          const data = new FormData()
          data.append('jsonBody', JSON.stringify(this.message))
          if (this.message.attachment) {
            data.append('files', this.message.attachment)
          }
          
          if (this.isResponse) {
            axios.post(`/tickets/${this.$route.params.id}/messages`, data).then(response => {
              this.$bus.$emit('response-send-success', response.data)
              store.modal.active = false
            })
          } else {
            axios.post('/tickets', data).then(response => {
              this.$bus.$emit('message-send-success', response.data)
              store.modal.active = false
            })
          }
        }
      })
    },

    /**
     * onSendSuccess
     */
    onSendMessageSuccess (response) {
      this.showBanner('success', response.message)
      store.modal.active = false
    },

    removeFile () {
      this.message.attachment = null
    }
  }
}
